import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ_ITEMS = [
  {
    question: 'Sind die Bewertungen echt?',
    answer: 'Ja. Wir zeigen ausschließlich Bewertungen von öffentlichen Plattformen wie Google und ProvenExpert. Keine erfundenen oder gefälschten Rückmeldungen.'
  },
  {
    question: 'Wo kann ich Bewertungen finden?',
    answer: 'Auf Google My Business und ProvenExpert. Die Links zu den Profilen werden in Kürze eingebunden.'
  },
  {
    question: 'Warum sind Bewertungen bei Gutachten wichtig?',
    answer: 'Sie geben einen Eindruck von Abläufen, Kommunikation und Zuverlässigkeit. Bei einem Unfallgutachten geht es um präzise Dokumentation – da hilft Orientierung durch Erfahrungen anderer.'
  },
  {
    question: 'Kann ich auch per WhatsApp Fragen stellen?',
    answer: 'Ja, selbstverständlich. Schreiben Sie uns über WhatsApp – wir antworten schnell und klären alle offenen Punkte.'
  },
  {
    question: 'Wie schnell bekommt man einen Termin?',
    answer: 'Meist innerhalb von 24–48 Stunden, je nach Region und Verfügbarkeit. Wir koordinieren das flexibel mit Ihnen.'
  },
  {
    question: 'Kommt ihr direkt vor Ort?',
    answer: 'Ja. Die Begutachtung erfolgt dort, wo sich Ihr Fahrzeug befindet – bundesweit. Sie müssen nicht zu uns fahren.'
  },
  {
    question: 'Was passiert nach der Begutachtung?',
    answer: 'Sie erhalten das fertige Gutachten zur Vorlage bei der Versicherung. Wir unterstützen Sie bei Fragen gerne weiter.'
  },
  {
    question: 'Kann ich vorher einen Eindruck bekommen?',
    answer: 'Rufen Sie uns an oder schreiben Sie per WhatsApp. Wir klären Ihre Fragen vorab und geben Ihnen eine erste Einschätzung.'
  }
];

export const FAQBewertungen = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            FAQ
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Rund um Bewertungen, Vertrauen und Ablauf
          </p>
        </div>

        <div className="bg-white border border-gray-100 rounded-3xl p-10 lg:p-16 shadow-modern-lg">
          <Accordion type="single" collapsible className="w-full space-y-5">
            {FAQ_ITEMS.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="border border-gray-200 rounded-2xl px-7 py-1 data-[state=open]:border-brand-green/40 data-[state=open]:shadow-xl transition-all bg-white"
              >
                <AccordionTrigger className="text-left font-bold text-gray-900 hover:text-brand-green py-6 hover:no-underline text-base lg:text-lg">
                  <div className="flex items-start gap-4">
                    <HelpCircle className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" />
                    <span className="pr-4">{item.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6 pl-10 text-[15px]">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-6 text-center">
          <a href="/nach-dem-unfall" className="text-brand-green hover:text-brand-green-dark font-semibold text-lg transition-colors">
            Nach dem Unfall →
          </a>
          <a href="/bundesweit" className="text-brand-green hover:text-brand-green-dark font-semibold text-lg transition-colors">
            Bundesweit →
          </a>
          <a href="/kontakt" className="text-brand-green hover:text-brand-green-dark font-semibold text-lg transition-colors">
            Kontakt →
          </a>
        </div>
      </div>
    </section>
  );
};